export interface SDKFeatureDefinition<Variation extends string = string> {
  readonly key: string
  readonly variations: readonly Variation[]
}

export type RemoteSDKFeatureDecisions = Record<string, string>
export type SDKFeatureDecisionResult<Variation extends string> = Variation | null | 'invalid'

export const SDK_FEATURES = {
  inlineGridIframe: {
    key: 'npo_donate_embedded_cpb_grid',
    variations: ['off', 'on'],
  },
} as const satisfies Record<string, SDKFeatureDefinition>

export const getSDKFeatureDecision = <Variation extends string>(
  decisions: unknown,
  feature: SDKFeatureDefinition<Variation>
): SDKFeatureDecisionResult<Variation> => {
  if (decisions == null) {
    return null
  }

  if (typeof decisions !== 'object' || Array.isArray(decisions)) {
    return 'invalid'
  }

  const value = (decisions as Record<string, unknown>)[feature.key]

  if (value == null) {
    return null
  }

  if (typeof value !== 'string' || !feature.variations.includes(value as Variation)) {
    return 'invalid'
  }

  return value as Variation
}
